module.exports = __webpack_public_path__ + "img/get-lucky.c7dea48c.gif";